import React, { useState } from 'react';
import './App.css';
import { OverviewTable } from './components';
import Login from './components/Login';
import { isAuthenticated } from './auth/auth';

function App() {
  const [authed, setAuthed] = useState(() => isAuthenticated());

  if (!authed) {
    return <Login onSuccess={() => setAuthed(true)} />;
  }

  return (
    <div className="min-h-screen bg-background p-2 sm:p-4 md:p-6">
      <OverviewTable placeholder="Search…" />
    </div>
  );
}

export default App;
